export const selectClientServiceMessages = {
  GET_ERROR: 'Unable to load clients. Please try again.',
  VIEW_AS_ERROR: 'Unable to switch to the selected client. Please try again.',
};
